/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import {
	CosmosComponentContextProps,
	getHero,
	ResearchCardsContainer,
	useCosmosComponentContext,
} from "@cosmos/components";
import { PageResearchFragment } from "@cosmos/hygraph-schema";
import { useAuth } from "@cosmos/next-hooks";

import { TemplateProviders } from "../templates/TemplateProviders";

interface CosmosPageProps {
	pageData?: PageResearchFragment;
	componentContext?: CosmosComponentContextProps;
}

export const CosmosPageResearch = ({ pageData, componentContext }: CosmosPageProps): React.JSX.Element => {
	const contextFromProvider = useCosmosComponentContext();
	const ctx = componentContext ?? contextFromProvider;
	useAuth(!ctx.enableAuth);

	// The hero (when present) owns the page h1 — tell the research section so its title
	// is an h1 only when no hero renders above it.
	const hero = getHero(pageData?.hero);

	return (
		<TemplateProviders componentContext={componentContext}>
			{hero}
			<ResearchCardsContainer
				items={pageData?.researchCards}
				config={pageData?.researchCardsSectionConfig}
				hasHero={Boolean(hero)}
			/>
		</TemplateProviders>
	);
};
